import { createSelector } from 'reselect';

const selectDbnpDbnpProducts = (state: any) => state.dbnpProducts;


export const selectDbnpProductCurrentItem = createSelector([selectDbnpDbnpProducts], (dbnpProducts) => dbnpProducts.current);

export const selectDbnpProductListItems = createSelector([selectDbnpDbnpProducts], (dbnpProducts) => dbnpProducts.list);

export const selectDbnpProductItemById = (itemId: any) =>
    createSelector(selectDbnpProductListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDbnpProductQueryItems = createSelector([selectDbnpDbnpProducts], (dbnpProducts) => dbnpProducts.query);

export const selectDbnpProductCreatedItem = createSelector([selectDbnpDbnpProducts], (dbnpProducts) => dbnpProducts.create);

export const selectDbnpProductPublishedItem = createSelector([selectDbnpDbnpProducts], (dbnpProducts) => dbnpProducts.publish);

export const selectDbnpProductUpdatedItem = createSelector([selectDbnpDbnpProducts], (dbnpProducts) => dbnpProducts.update);

export const selectDbnpProductReadItem = createSelector([selectDbnpDbnpProducts], (dbnpProducts) => dbnpProducts.read);

export const selectDbnpProductUploadCreateItem = createSelector([selectDbnpDbnpProducts], (dbnpProducts) => dbnpProducts.uploadCreate);

export const selectDbnpProductDeletedItem = createSelector([selectDbnpDbnpProducts], (dbnpProducts) => dbnpProducts.delete);

export const selectDbnpDbnpProductsearchedItems = createSelector([selectDbnpDbnpProducts], (dbnpProducts) => dbnpProducts.search);

export const selectDbnpProductItemsCount = createSelector([selectDbnpDbnpProducts], (dbnpProducts) => dbnpProducts.count);

export const selectDbnpProductItemsFilter = createSelector([selectDbnpDbnpProducts], (dbnpProducts) => dbnpProducts.filter);

export const selectDbnpDbnpProductsummaryItems = createSelector([selectDbnpDbnpProducts], (dbnpProducts) => dbnpProducts.summary);